import { Container } from "react-bootstrap";
import onlinebanner from "../assets/img/inner-banner/Online-Service.webp";
import onlinebannerMobile from "../assets/img/mobile-banner/Online-Service.webp";

import sealing from "../assets/img/SEALING-SERVICES.jpg";
import hologram from "../assets/img/HOLOGRAM-SECURITY.jpg";
import online from "../assets/img/Online-Services.webp";
import "./ServiceDetails.css";
import { Link } from "react-router-dom";
import {
  MdKeyboardDoubleArrowRight,
  MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";
import { IoCheckmarkDone } from "react-icons/io5";
import { Helmet } from "react-helmet";

export default function Online() {
  return (
    <>
      <Helmet>
        {/* Meta tags */}
        <title>
          Online Diamond Certification Services | Sreehari Diamond Laboratory{" "}
        </title>
        <meta
          name="description"
          content="Verify your diamond certificate instantly with our secure online diamond certificate verification service.  Trusted solutions for retailers, dealers, and buyers across India."
        />
        <meta
          name="keywords"
          content="lab grown diamond certification, best diamond certification in india, Gemstone Identification Lab, Diamond, Gemological Laboratory, Diamond Testing Lab, Diamond Sealing service, Diamond Hologram Stickers, Hologram Stickers for Certificates, Best diamond online services"
        />
        {/* OG tags */}
        <meta
          property="og:title"
          content="Online Diamond Certification Services | Sreehari Diamond Laboratory"
        />
        <meta
          property="og:description"
          content="Verify your diamond certificate instantly with our secure online diamond certificate verification service.  Trusted solutions for retailers, dealers, and buyers across India."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://sreeharidiamondlab.com/online-certificate-verification"
        />
        <meta
          property="og:image"
          content="https://sreeharidiamondlab.com/static/media/Online-Services.7fcd3818ea5424305bd3.webp"
        />
        <meta property="og:site_name" content="sreehari diamond laboratory" />
        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="Online Diamond Certification Services | Sreehari Diamond Laboratory"
        />
        <meta
          name="twitter:description"
          content="Verify your diamond certificate instantly with our secure online diamond certificate verification service.  Trusted solutions for retailers, dealers, and buyers across India."
        />
        <meta
          name="twitter:image"
          content="https://sreeharidiamondlab.com/static/media/Online-Services.7fcd3818ea5424305bd3.webp"
        />
        <meta name="twitter:site" content="sreehari diamond laboratory" />
        <link
          rel="canonical"
          href="https://sreeharidiamondlab.com/online-certificate-verification"
        />{" "}
      </Helmet>
      <section>
        <Container fluid className="bannersection position-relative p-0">
          <img
            src={window.innerWidth > 568 ? onlinebanner : onlinebannerMobile}
            alt="Service banner"
            className="w-100  h-100 object-fit-cover about-banner-img"
          />
          <div className="textoverlay pt-5 d-flex flex-column justify-content-center align-items-center position-absolute top-0 w-100 h-100 text-center"></div>
        </Container>
      </section>
      <section className="hologram-section section-spacing-x section-spacing-y pb-0">
        <div className="container-fluid">
          <div className="row">
            <h1 className="heading mb-3 text-center">
              Online Diamond Certificate Verification Service{" "}
            </h1>
          </div>
          <p>
            Our Online Certificate Verification Service allows you to quickly
            and securely verify the authenticity of your diamond certification
            anytime, anywhere. Simply enter your certificate number on our
            website to access detailed, real-time information about your
            gemstone's grading report. This convenient digital service enhances
            transparency and trust, helping buyers, sellers, and collectors
            confirm the legitimacy of their diamonds with ease. By providing
            instant access to verified certification data, we ensure peace of
            mind and confidence throughout every transaction.{" "}
          </p>
          <div className="row">
            <div className="col-lg-8 content-para">
              <h3>How It Works:</h3>
              <p>1. Locate the serial number printed on the certificate. </p>
              <p>
                2. Enter the number in our secure online verification portal.{" "}
              </p>
              <p>
                3. Instantly view grading results, gemstone specifications, and
                certificate status.{" "}
              </p>
              <h3>Key Benefits:</h3>
              <p>
                <IoCheckmarkDone /> Instant certificate validation for
                customers, jewellers, and dealers{" "}
              </p>
              <p>
                <IoCheckmarkDone /> 24/7 access to grading reports{" "}
              </p>
              <p>
                <IoCheckmarkDone /> Protects against fake or altered
                certificates{" "}
              </p>
              <p>
                <IoCheckmarkDone />
                Builds trust and confidence in every transaction{" "}
              </p>
              <div className="contact-us-button mt-lg-4 mb-lg-3 mb-4">
                <Link to="/contact-us">
                  Contact Us <MdOutlineKeyboardDoubleArrowRight />
                </Link>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="online-left-image">
                <img src={online} className="img-fluid" />
              </div>
            </div>
          </div>
          {/* <h3>Verify a Certificate Now: </h3>
          <p>Enter Certificate Number: </p>
          <p>View Original Certificate:</p> */}
        </div>
      </section>
      <section className="section-spacing-x">
        <div className="container-fluid">
          <div className="row mb-5 mt-lg-0 mt-4">
            <h2 className="text-center mb-4 heading">Other Services</h2>
            <div className="col-lg-4 mb-lg-0 mb-3">
              <div className="service-card text-center border rounded p-2 ">
                <div className="service-image mx-auto">
                  <img
                    src={sealing}
                    alt="Diamond Sealing Service | Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/diamond-sealing-service">
                  <Link to="/diamond-sealing-service">
                    <h3 className="mt-0">Sealing Service</h3>
                  </Link>
                </Link>
                <p className="mt-0">
                  Our Sealing Service ensures your diamonds are protected in
                  tamper-proof holders, preserving authenticity and value.{" "}
                </p>
                <div className="service-read-more mb-3">
                  <Link to="/diamond-sealing-service">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="service-card text-center border rounded p-2">
                <div className="service-image mx-auto">
                  <img
                    src={hologram}
                    alt="Diamond Hologram Security Stickers | Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/diamond-hologram-stickers">
                  <Link to="/diamond-hologram-stickers">
                    <h3 className="mt-0">Hologram Security</h3>
                  </Link>
                </Link>

                <p className="mt-0">
                  Our innovative Diamond Hologram Service adds a secure,
                  anti-counterfeit layer to every certified diamond,
                  guaranteeing easy verification.{" "}
                </p>
                <div className="service-read-more mb-3">
                  <Link to="/diamond-hologram-stickers">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
